export enum ErrorCode {
  UNDER_MAINTENANCE = 'under-maintenance',
  INVALID_LOGIN_STATUS = 'invalid-login-status',
  INVALID_DEVICE = 'invalid-device'
}
